// extracted by mini-css-extract-plugin
module.exports = {"icon":"SimpleCallout-module__icon___1DrZD","title":"SimpleCallout-module__title___22QsA","callout-text":"SimpleCallout-module__callout-text___1Uo08"};